export default "__VITE_ASSET__e57f5d8a__"